import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Link from "@mui/material/Link";
// import LabelIcon from "@mui/icons-material/Label";
import Icon from "@mui/material/Icon";

import NavBreadcrumbs from "../NavBreadcrumbs/NavBreadcrumbs";

import jeevaindustrieslogo from "../../assets/img/logo.png";

// const pages = [
//   "About us",
//   "Our Activity",
//   "We Expertise",
//   "Machine Details",
//   "Kitchen Equipments",
//   "Contact us",
// ];

const pages = [
  {
    label: "Our Activity",
    icon: "work",
  },
  {
    label: "Our Products Range",
    icon: "engineering",
  },
  {
    label: "Machine Details",
    icon: "settings",
  },
  {
    label: "Contact us",
    icon: "place",
  },
  // {
  //   label: "Kitchen Equipments",
  //   icon: "countertops",
  // },
];

const Header = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const actionScrollToElement = (e: any, sectionName: string) => {
    e.preventDefault(); // Stop Page Reloading
    e.stopPropagation();
    let sectionElement = document.getElementById(
      sectionName.toLowerCase().trim().replaceAll(" ", "-")
    );
    const headElemet = document.getElementById("app-header-id");
    const headerOffset = headElemet && headElemet.offsetHeight;
    const elementPosition =
      sectionElement && sectionElement.getBoundingClientRect().top;
    if (elementPosition && headerOffset) {
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  return (
    <div className="app-header" id="app-header-id">
      <AppBar position="static" className="app-header__appBar">
        <Container maxWidth={false}>
          <Toolbar disableGutters>
            {/* <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <img
                src={jeevaindustrieslogo}
                height="60px"
                alt="app logo"
                className="app-logo"
              />
            </Typography>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href=""
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <img
                src={jeevaindustrieslogo}
                height="60px"
                alt="app logo"
                className="app-logo"
              />
            </Typography> */}

            {location.pathname !== "/kitchen-equipments" ? (
              [
                <Box
                  className="nav-menu-wrapper-desktop"
                  sx={{
                    flexGrow: 1,
                    display: { xs: "none", md: "flex" },
                  }}
                >
                  <div className="nav-menu-container-desktop">
                    <Box
                      sx={{
                        flexGrow: 1,
                        justifyContent: "space-between",
                        display: { xs: "none", md: "flex" },
                      }}
                    >
                      {pages.map((page, pageIndex) => {
                        const menuLinkItem = [
                          <Link
                            component="button"
                            className="nav-menu-desktopLinkText"
                            variant="body2"
                            key={page.label}
                            onClick={(e) => {
                              handleCloseNavMenu();
                              if (page.label === "Kitchen Equipments") {
                                navigate("/kitchen-equipments", {
                                  replace: false,
                                });
                              } else {
                                actionScrollToElement(e, page.label);
                              }
                            }}
                            sx={{
                              my: 2,
                              color: "#666",
                              display: "block",
                              textDecoration: "none",
                              fontWeight: "bold",
                              padding: "0px 14px",
                              "&:hover": {
                                color: "#f16c4e",
                              },
                            }}
                          >
                            {page.label}
                          </Link>,
                        ];
                        if (pageIndex === 1) {
                          menuLinkItem.push(
                            <a href="/">
                              <img
                                src={jeevaindustrieslogo}
                                height="100px"
                                alt="app logo"
                                className="app-logo"
                              />
                            </a>
                          );
                        }
                        return menuLinkItem;
                      })}
                    </Box>
                  </div>
                </Box>,
                <Box
                  className="nav-menu-wrapper-mobile"
                  sx={{
                    flexGrow: 0,
                    color: "#666",
                    display: { xs: "flex", md: "none" },
                  }}
                >
                  <div>
                    <a href="/">
                      <img
                        src={jeevaindustrieslogo}
                        height="60px"
                        alt="app logo"
                        className="app-logo"
                      />
                    </a>
                  </div>
                  <div>
                    <h4
                      style={{ color: "#012b52", textTransform: "uppercase" }}
                    >
                      Jeeva Industries
                    </h4>
                  </div>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{
                      display: { xs: "block", md: "none" },
                    }}
                  >
                    {pages.map((page) => (
                      <MenuItem
                        key={page.label}
                        onClick={(e) => {
                          handleCloseNavMenu();
                          if (page.label === "Kitchen Equipments") {
                            navigate("/kitchen-equipments", { replace: false });
                          } else {
                            actionScrollToElement(e, page.label);
                          }
                        }}
                      >
                        <ListItemIcon>
                          {/* <LabelIcon fontSize="small" /> */}
                          <Icon fontSize="small">{page.icon}</Icon>
                        </ListItemIcon>
                        <Typography textAlign="center">{page.label}</Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>,
              ]
            ) : (
              <Box
                className="nav-menu-wrapper-breadcrumbs"
                sx={{
                  flexGrow: 1,
                  justifyContent: "end",
                  display: { xs: "flex", md: "flex" },
                }}
              >
                <NavBreadcrumbs />
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default Header;
